/** Mirrors project landing used after login (overview vs NDA gate vs dataroom). */
export function getProjectHomePath(currentProject, user) {
    if (!currentProject || !user?.id) {
        return '/project';
    }
    if (user.has_diligence_tools) {
        return '/overview';
    }
    const userData = currentProject?.vdr?.nda?.signees?.find(item => item?.user === user?.id);
    if (userData?.nda_signed === false) {
        return '/nda';
    }
    return '/dataroom';
}
